import { DATE_TEMPLATES, DateFormatValue, day, diff, format } from '~/astra'

export function getTimeStampText(time: string, dateTemplate: DateFormatValue = DATE_TEMPLATES.compactDateTime) {
    const timeDate = day(time)
    const now = day()
    const diffDays = diff(now, timeDate, 'days')

    // was today
    if (diffDays === 0) {
        const diffMinutes = diff(now, timeDate, 'minutes')
        if (diffMinutes < 5) {
            return 'nå'
        }
        if (diffMinutes < 60) {
            return `${diffMinutes} min siden`
        }
        const diffHours = diff(now, timeDate, 'hours')
        if (diffHours < 2) {
            return `${diffHours} time siden`
        }
        if (diffHours < 24) {
            return `${diffHours} timer siden`
        }
        return 'i dag'
    }
    // was yesterday
    if (diffDays === 1) {
        return 'i går'
    }

    return format(timeDate, dateTemplate)
}
